import { render, staticRenderFns } from "./moveToProgramme.vue?vue&type=template&id=2cbd4657"
import script from "./moveToProgramme.vue?vue&type=script&lang=js"
export * from "./moveToProgramme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports